import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { SupportService } from 'src/app/api/support.service';

@Component({
  selector: 'auth-register-marketer',
  templateUrl: './register-marketer.component.html',
  styleUrls: ['./register-marketer.component.scss']
})
export class RegisterMarketerComponent implements OnInit {

  loading = false;
  error: string = null;
  success = false;

  form = this.fb.group({
    email: [null, [Validators.required, Validators.email]],
    name: [null, Validators.required],
    company: [null],
    message: [null]
  });

  constructor(private fb: FormBuilder, private supportService: SupportService) { }

  ngOnInit() {
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      this.error = null;
      this.supportService.send('general', {
        title: `Marketer Request | ${this.name.value}`,
        email: this.email.value,
        message: `
          Name: ${this.name.value} <br/>
          Company: ${this.company.value} <br/>
          Message: <br/>
          <br/>
          ${this.message.value}
        `
      }).subscribe(response => {
        this.loading = false;
        this.success = true;
      }, err => {
        this.loading = false;
        this.error = err.errors[0].message;
      })

    } else {
      this.error = 'Please fill out the required fields';
    }
  }

  get email() { return this.form.get('email'); }
  get name() { return this.form.get('email'); }
  get company() { return this.form.get('company'); }
  get message() { return this.form.get('message'); }
}
